import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import {ProfilManagerService} from '../../../modules/profil/profil-manager.service';
import {HydraService} from '../../../core/services/hydra.service';
import {ExUtilisateur} from '../../../class/ex/ex-utilisateur';
import {Subscription} from 'rxjs';
import {GeocoderComponent} from '../geocoder/geocoder.component';
import {MatDialog} from '@angular/material/dialog';
import {
    ModalChoixLaboratoireReferenceComponent
} from '../modal-choix-laboratoire-reference/modal-choix-laboratoire-reference.component';
import {LaboratoireReference} from '../../../class/api/LaboratoireReference';
import {Adresse} from '../../../class/api/Adresse';
import {ExCountry} from '../../../class/ex/ex-country';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {ToolsService} from '../../services/tools/tools.service';
import {Laboratoire, LaboratoireInterface} from '../../../class/api/Laboratoire';
import {Personne} from '../../../class/api/Personne';
import {PersonneResponsable} from '../../../class/api/PersonneResponsable';
import {ModalModifierLaboratoireComponent} from '../modal-modifier-laboratoire/modal-modifier-laboratoire.component';
import {LaboratoireReferenceSuggestion} from '../../../class/api/LaboratoireReferenceSuggestion';
import {ModalConfirmationComponent} from '../modal-confirmation/modal-confirmation.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-lab-struct-and-perso',
    templateUrl: './lab-struct-and-perso.component.html',
    styleUrls: ['./lab-struct-and-perso.component.scss'],
    imports: [MatButton, MatIcon, FormsModule, GeocoderComponent, MatSelect, MatOption, TranslateModule]
})
export class LabStructAndPersoComponent implements OnInit {
    userService = inject(ProfilManagerService);
    private hydraService = inject(HydraService);
    private matDialog = inject(MatDialog);
    private toolService = inject(ToolsService);
    private ngxTranslateService = inject(TranslateService);

    public newLabFr = false;
    private subscriptions: Subscription[] = [];
    public user: ExUtilisateur = null;
    public labo: LaboratoireInterface = null;

    public uniteInsermSelected = false;
    public uniteCnrsSelected = false;
    public universiteFaculteSelected = false;

    @ViewChild('geocoder', {static: true}) geocoder: GeocoderComponent;
    @Input() laboratoire: LaboratoireInterface = null;

    @Output('updateLaboratoire') updateLaboratoireEvent: EventEmitter<any> = new EventEmitter();

    public isValid() {
        //Labo de ref existe
        if (this.user.laboratoire['laboratoireReference'] == null) {
            return false;
        }
        //Labo de ref hors france valid
        if (!this.laboEnFrance() || this.newLabFr) {
            //structure france label
            if (
                this.user.laboratoire['laboratoireReference']['label'] == null ||
                this.user.laboratoire['laboratoireReference']['label'] == undefined ||
                this.user.laboratoire['laboratoireReference']['label'] == ''
            ) {
                return false;
            }
            //structure france Directeur
            if (
                this.user.laboratoire['laboratoireReference']['directeur'][
                    'civilite'
                    ] == null
            ) {
                return false;
            }
            if (
                this.user.laboratoire['laboratoireReference']['directeur'][
                    'nom'
                    ] == null ||
                this.user.laboratoire['laboratoireReference']['directeur'][
                    'nom'
                    ] == ''
            ) {
                return false;
            }
            if (
                this.user.laboratoire['laboratoireReference']['directeur'][
                    'prenom'
                    ] == null ||
                this.user.laboratoire['laboratoireReference']['directeur'][
                    'prenom'
                    ] == ''
            ) {
                return false;
            }
            //Structure adresse
            if (
                this.user.laboratoire['laboratoireReference']['adresse'][
                    'pays'
                    ] == null ||
                this.user.laboratoire['laboratoireReference']['adresse'][
                    'pays'
                    ] == ''
            ) {
                return false;
            }
            if (
                this.user.laboratoire['laboratoireReference']['adresse'][
                    'ville'
                    ] == null ||
                this.user.laboratoire['laboratoireReference']['adresse'][
                    'ville'
                    ] == ''
            ) {
                return false;
            }
            if (
                this.user.laboratoire['laboratoireReference']['adresse'][
                    'numEtVoie'
                    ] == null ||
                this.user.laboratoire['laboratoireReference']['adresse'][
                    'numEtVoie'
                    ] == ''
            ) {
                return false;
            }
            if (
                this.user.laboratoire['laboratoireReference']['adresse'][
                    'codePostal'
                    ] == null ||
                this.user.laboratoire['laboratoireReference']['adresse'][
                    'codePostal'
                    ] == ''
            ) {
                return false;
            }
        }
        //Labo perso adresse invalide
        if (
            this.geocoder != undefined &&
            this.geocoder != null &&
            !this.geocoder.isValid()
        ) {
            return false;
        }
        //Info labo perso
        if (
            this.user.laboratoire['nom'] == null ||
            this.user.laboratoire['nom'] == ''
        ) {
            return false;
        }

        return true;
    }

    public update() {
        if (this.isValid()) {
            this.updateLaboratoireEvent.emit(this.user['laboratoire']);
        }
    }

    //trads
    private messageModifStruct = 'field.laboratoire.modifStructureLabel';
    private messageDemandeChangementLabo = 'field.laboratoire.valideDemandeChangement';
    private messageAnnuler = 'general.annuler';
    private messageDemandeEnvoye = 'field.laboratoire.demandeChangementEnvoye';
    private messageSaisieLibre = 'general.saisieLibre';

    constructor() {
        const temp = this.userService.profil;
        if (temp.laboratoire == null) {
            temp.laboratoire = new Laboratoire() as any;
            temp.laboratoire['directeurDivision'] = new PersonneResponsable();
            temp.laboratoire['directeurDivision']['personne'] = new Personne();
            temp.laboratoire['adresse'] = new Adresse();
        }

        this.user = new ExUtilisateur(temp);
        this.getCountry();
        this.getunite();
        this.getTranslations();
    }

    public getTranslations() {
        this.subscriptions.push(this.ngxTranslateService.get(this.messageModifStruct).subscribe(res => this.messageModifStruct = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageDemandeChangementLabo).subscribe(res => this.messageDemandeChangementLabo = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageAnnuler).subscribe(res => this.messageAnnuler = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageDemandeEnvoye).subscribe(res => this.messageDemandeEnvoye = res));
        this.subscriptions.push(this.ngxTranslateService.get(this.messageSaisieLibre).subscribe(res => this.messageSaisieLibre = res));
    }

    public compareByid(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.id == itemTwo.id;
    }

    public compareByCode(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.code == itemTwo.code;
    }

    public compareByLetter(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }

    public countries: ExCountry[] = [];

    public getCountry() {
        this.hydraService.getList(api.countries, true).subscribe(res => {
            this.countries = res.getMember();

            if (
                this.user.laboratoire != null &&
                typeof this.user.laboratoire != 'string' &&
                this.user.laboratoire['laboratoireReference'] != null
            ) {
                if (
                    this.user.laboratoire['laboratoireReference']['adresse'] !=
                    null &&
                    typeof this.user.laboratoire['laboratoireReference'][
                        'adresse'
                        ]['pays'] == 'string'
                ) {
                    this.countries.forEach(item => {
                        if (
                            item['@id'] ==
                            this.user.laboratoire['laboratoireReference'][
                                'adresse'
                                ]['pays']
                        ) {
                            this.user.laboratoire['laboratoireReference'][
                                'adresse'
                                ]['pays'] = item;
                            this.update();
                        }
                    });
                }

                if (
                    this.user.laboratoire != null &&
                    this.user.laboratoire['adresse'] != null &&
                    typeof this.user.laboratoire['adresse']['pays'] == 'string'
                ) {
                    this.countries.forEach(item => {
                        if (
                            item['@id'] ==
                            this.user.laboratoire['adresse']['pays']
                        ) {
                            this.user.laboratoire['adresse']['pays'] = item;
                            this.update();
                        }
                    });
                }
            } else {
                if (
                    this.user.laboratoire != null &&
                    typeof this.user.laboratoire == 'string'
                ) {
                    this.getLabo();
                }
            }
        });
    }

    public getLabo() {
        if (!this.user.laboratoire || !(typeof this.user.laboratoire === 'string')) {
            this.getCountry();
            this.getunite();
            return;
        }
        this.hydraService.getItem(this.user.laboratoire).subscribe(res => {
            this.user.laboratoire = res as any;
            this.getCountry();
            this.getunite();
        });
    }

    public deleteLaboRef() {
        const dialog = this.matDialog.open(ModalConfirmationComponent);
        dialog.afterClosed().subscribe(res => {
            if (res && res == true) {
                this.user.laboratoire['laboratoireReference'] = null;
                this.update();
            }
        });
    }

    public demandeDeModification() {
        const dialog = this.matDialog.open(ModalModifierLaboratoireComponent, {
            data: {
                content: this.messageModifStruct,
                confirm: this.messageDemandeChangementLabo,
                cancel: this.messageAnnuler,
            },
        });
        dialog.afterClosed().subscribe(res => {
            if (res && res.length) {
                const data = new LaboratoireReferenceSuggestion({
                    commentaire: res,
                    laboratoireReference: this.user.laboratoire[
                        'laboratoireReference'
                        ]['@id'],
                });

                this.hydraService
                    .post(api.laboratoireReferenceSuggestion, data)
                    .subscribe(() => {
                        this.toolService.notificationInfo(
                            this.messageDemandeEnvoye,
                            3000
                        );
                    });
            }
        });
    }

    public searchStructure() {
        const dialog = this.matDialog.open(
            ModalChoixLaboratoireReferenceComponent,
            {
                width: '1000px',
                height: 'auto',
                data: {
                    newReference: false,
                },
            }
        );
        dialog
            .afterClosed()
            .subscribe((res: LaboratoireReference | boolean) => {
                if (res) {
                    this.user.laboratoire['laboratoireReference'] = res;
                    if (res['adresse'] != null) {
                        //Auto completion de l'adresse par contre on créer bien une nouvelle Instance en BDD
                        delete res['adresse']['@id'];
                        delete res['adresse']['id'];
                        this.user.laboratoire['adresse'] = new Adresse(
                            res['adresse']
                        );
                        this.geocoder.setAdresse(new Adresse(res['adresse']));
                    }
                    this.update();
                }
                if (res == false) {
                    // console.log("Je n'ai pas trouvé ma strucutre");
                    this.addNewLaboRef(true);
                }
            });
    }

    public laboEnFrance(): boolean {
        return (
            this.user.laboratoire != null &&
            this.user.laboratoire['laboratoireReference'] != null &&
            this.user.laboratoire['laboratoireReference']['adresse'] != null &&
            this.user.laboratoire['laboratoireReference']['adresse']['pays'] !=
            null &&
            (this.user.laboratoire['laboratoireReference']['adresse']['pays'] ==
                '/api/countries/FR' ||
                (this.user.laboratoire['laboratoireReference']['adresse'][
                        'pays'
                        ]['code'] != undefined &&
                    this.user.laboratoire['laboratoireReference']['adresse'][
                        'pays'
                        ]['code'] == 'FR') ||
                (this.user.laboratoire['laboratoireReference']['adresse'][
                        'pays'
                        ]['code'] != undefined &&
                    this.user.laboratoire['laboratoireReference']['adresse'][
                        'pays'
                        ]['@id'] == '/api/countries/FR'))
        );
    }

    //Select pour l'étape Mon Laboratoire
    public uniteInserm: any[] = [];
    public filteredUniteInserm: any[] = [];
    public uniteInsermSearch: any = '';

    public universiteFaculte: any[] = [];
    public filteredUniversiteFaculte: any[] = [];
    public universiteFaculteSearch: any = '';

    public uniteCnrs: any[] = [];
    public filterdUniteCnrs: any[] = [];
    public uniteCnrsSearch: any = '';

    getunite() {
        this.hydraService
            .getList(api.inserm + '?enabled=true&itemsPerPage=500', false)
            .subscribe(res => {
                this.uniteInserm = new HydraCollection(res).getMember();
                this.filteredUniteInserm = [...this.uniteInserm].filter(
                    item => item.enabled
                );
                if (this.user.laboratoire) {
                    //CNRS
                    if (
                        this.user.laboratoire['uniteInsermOther'] != null ||
                        this.user.laboratoire['uniteInserm'] != null
                    )
                        {this.uniteInsermSelected = true;}
                    if (
                        this.user.laboratoire['uniteInsermOther'] != null &&
                        this.user.laboratoire['uniteInsermOther'].length
                    ) {
                        this.uniteInserm.map(item => {
                            if (
                                item['code'] != undefined &&
                                item['code'] == 'ZZZ_OTHER'
                            ) {
                                this.uniteInsermSearch = item;
                            }
                        });
                    } else {
                        this.uniteInsermSearch = this.user.laboratoire[
                            'uniteInserm'
                            ];
                    }
                }
            });

        this.hydraService
            .getList(api.cnrs + '?enabled=true&itemsPerPage=500', false)
            .subscribe(res => {
                this.uniteCnrs = new HydraCollection(res).getMember();
                this.filterdUniteCnrs = [...this.uniteCnrs].filter(
                    item => item.enabled
                );

                if (this.user.laboratoire) {
                    //CNRS
                    if (
                        this.user.laboratoire['uniteCnrsOther'] != null ||
                        this.user.laboratoire['uniteCnrs'] != null
                    )
                        {this.uniteCnrsSelected = true;}
                    if (
                        this.user.laboratoire['uniteCnrsOther'] != null &&
                        this.user.laboratoire['uniteCnrsOther'].length
                    ) {
                        this.uniteCnrs.map(item => {
                            if (
                                item['code'] != undefined &&
                                item['code'] == 'ZZZ_OTHER'
                            ) {
                                this.uniteCnrsSearch = item;
                            }
                        });
                    } else {
                        this.uniteCnrsSearch = this.user.laboratoire[
                            'uniteCnrs'
                            ];
                    }
                }
            });

        this.hydraService
            .getList(api.universiteFaculte + '?enabled=true&itemsPerPage=500', false)
            .subscribe(res => {
                this.universiteFaculte = new HydraCollection(res).getMember();
                this.filteredUniversiteFaculte = [
                    ...this.universiteFaculte,
                ].filter(item => item.enabled);
                if (this.user.laboratoire) {
                    //CNRS
                    if (
                        this.user.laboratoire['universiteFaculteOther'] !=
                        null ||
                        this.user.laboratoire['universiteFaculte'] != null
                    )
                        {this.universiteFaculteSelected = true;}
                    if (
                        this.user.laboratoire['universiteFaculteOther'] !=
                        null &&
                        this.user.laboratoire['universiteFaculteOther'].length
                    ) {
                        this.universiteFaculte.map(item => {
                            if (
                                item['titre'] != undefined &&
                                item['titre'] == 'ZZZ_OTHER'
                            ) {
                                this.universiteFaculteSearch = item;
                            }
                        });
                    } else {
                        this.universiteFaculteSearch = this.user.laboratoire[
                            'universiteFaculte'
                            ];
                    }
                }
            });
    }

    public displayAutoCompleteLabel(item: any) {
        if (item && item['titre'] != undefined) {
            if (item['titre'] == 'ZZZ_OTHER') {
                return this.messageSaisieLibre;
            } else {
                return item['titre'];
            }
        } else {
            return '';
        }
    }

    public displayAutoComplete(item: any) {
        if (item && item['code'] != undefined) {
            if (item['code'] == 'ZZZ_OTHER') {
                return this.messageSaisieLibre;
            } else {
                return item['code'];
            }
        } else {
            return '';
        }
    }

    public resetResearch(
        ngModel: string,
        dataSource: string,
        dateSourceFiltered: string
    ) {
        setTimeout(_ => {
            if (typeof this[ngModel] == 'string') {
                this[ngModel] = '';
                this[dateSourceFiltered] = [...this[dataSource]].filter(
                    item => item.enabled
                );
            }
        }, 200);
    }

    public filterSelect(
        str = '',
        dataSource: string,
        dateSourceFiltered: string
    ) {
        this[
            dateSourceFiltered
            ] = this.toolService
            .filterForNgModelAutoComplete(str, 'code', this[dataSource])
            .filter(item => item.enabled);
    }

    public filterSelectLabel(
        str = '',
        dataSource: string,
        dateSourceFiltered: string
    ) {
        this[
            dateSourceFiltered
            ] = this.toolService
            .filterForNgModelAutoComplete(str, 'titre', this[dataSource])
            .filter(item => item.enabled);
    }

    public updateSelect(str : []|string = '', itemOther: string, otherKey: string) {
        if (typeof str === 'object') {
            if (str[otherKey] != undefined) {
                if (str[otherKey] != 'ZZZ_OTHER') {
                    this.user.laboratoire[itemOther] = str[otherKey];
                }
            }
        } else {
            this.user.laboratoire[itemOther] = null;
        }
        this.update();
    }

    public addNewLaboRef(newFr: boolean = false) {
        const structure = new LaboratoireReference();
        structure['isMine'] = true;
        if (newFr) {
            this.newLabFr = true;
            const tmp = {
                '@id': '/api/countries/FR',
                code: 'FR',
            };
            structure.adresse = new Adresse({pays: tmp});
        } else {
            structure.adresse = new Adresse();
        }
        structure.directeur = new Personne();
        this.user.laboratoire['laboratoireReference'] = structure;
        this.update();
    }

    updateSelectBox(checked, itemOther: string) {
        if (!checked) {
            this.user.laboratoire[itemOther] = null;
        }
        this.update();
    }

    public laboratoireReferenceNonModifiable() {
        if (this.user.laboratoire == null || this.user.laboratoire['laboratoireReference'] == null) {
            return false;
        }
        // A moi + non validé
        else if (this.user.laboratoire['laboratoireReference']['isMine'] && +this.user.laboratoire['laboratoireReference']['etat'] === 0) {
            return true;
        }
        // A moi + hors france
        else {return this.user.laboratoire['laboratoireReference']['isMine'] && +this.user.laboratoire['laboratoireReference']['etat'] === 3;}
    }

    ngOnInit() {
    }
}
